import React, { createContext, useCallback, useRef, useState } from 'react';
import { ConfirmDialog } from './ConfirmDialog';
import { ResultDialog } from './ResultDialog';

export const FeedbackContext = createContext({
  confirm: async () => false,
  notify: () => {},
});

export function FeedbackProvider({ children }) {
  const [confirmState, setConfirmState] = useState(null);
  const [resultState, setResultState] = useState(null);
  const resolver = useRef(null);

  const confirm = useCallback((opts) => new Promise((resolve) => {
    resolver.current = resolve;
    setConfirmState({
      confirmLabel: 'Confirm',
      cancelLabel: 'Cancel',
      tone: 'default',
      ...opts,
    });
  }), []);

  const settle = (val) => {
    setConfirmState(null);
    if (resolver.current) {
      resolver.current(val);
      resolver.current = null;
    }
  };

  const notify = useCallback((opts) => {
    setResultState({ status: 'success', ...opts });
  }, []);

  return (
    <FeedbackContext.Provider value={{ confirm, notify }}>
      {children}
      {confirmState && (
        <ConfirmDialog
          {...confirmState}
          onConfirm={() => settle(true)}
          onCancel={() => settle(false)}
        />
      )}
      {resultState && (
        <ResultDialog
          {...resultState}
          onClose={() => setResultState(null)}
        />
      )}
    </FeedbackContext.Provider>
  );
}
